import { MailFilled, PhoneFilled, QuestionOutlined } from "@ant-design/icons";
import LoginForm from "./components/LoginForm";
import ConfigRepo from "@/core/repos/config.repo";
import container from "@/lib/di/container";
import { useEffect } from "react";
const configRepo = container.get(ConfigRepo);
const androidUrl = process.env.REACT_APP_STOREURL_ANDROID;
const iosUrl = process.env.REACT_APP_STOREURL_IOS;
const companyName = process.env.REACT_APP_COMPANY_NAME;
const factoryName = process.env.REACT_APP_COMPANY_FACTORY;

export default function LoginPage() {
  const buildStyles = configRepo.useBuildStyles();

  useEffect(() => {
    document.title = "Đăng nhập";
  })

  return (
    <section className="flex flex-row w-screen h-screen"
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/resources/brand/factory.webp')`,
        backgroundSize: "cover",
        backgroundPosition: "25vw 0px"
      }}>
      <div className="relative h-full bg-[#F5F7F9] pt-5 text-gray-800 overflow-y-clip flex items-center justify-start flex-col flex-1 z-10">
        <img
            src="/resources/brand/logo.png"
            alt="Nhà máy nước"
            style={buildStyles.get('loginLogo')??{width: 60}}
        />
        <p className="font-bold text-primary text-xl mb-8">HỆ THỐNG QUẢN LÝ KINH DOANH NƯỚC SẠCH</p>
        <div className="px-8 py-8 w-[440px] bg-white rounded mb-6">
          <p className="font-bold mb-4 text-lg">ĐĂNG NHẬP</p>
          <LoginForm />
        </div>
        <p className="text-base mb-2 mt-2">Tải ứng dụng ngay bây giờ:</p>
        <div className="flex flex-row mb-4 gap-x-2 flex-wrap items-center gap-y-2">
          <a href={iosUrl} target="_blank" rel="noopener noreferrer">
            <img src="/images/app-store-download.png" alt="Tải xuống ứng dụng từ appstore" height={50} width={140}/>
          </a>
          <a href={androidUrl} target="_blank" rel="noopener noreferrer">
            <img src="/images/chplay-download.png" alt="Tải xuống ứng dụng từ chplay" height={50} width={140}/>
          </a>
        </div>
        <div className="absolute bottom-0 left-0 p-2 flex flex-row justify-between items-end w-full">
          <div className="flex flex-col">
            <p className="font-bold text-xs text-gray-700">{companyName}</p>
            <p className="text-xs text-gray-700">{factoryName}</p>
          </div>
          <div>
            <div className="flex flex-row items-center mx-2">
              <div className="w-5 h-5 rounded-full bg-gray-800 mr-2 flex justify-center items-center">
                <QuestionOutlined className="text-xs font-bold" style={{color: 'white'}}/>
              </div>
              <p className="text-sm mb-0.5">Hướng dẫn sử dụng</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1">  
        <div className="absolute bottom-1.5 right-1.5">
          <div className="flex flex-row text-white text-sm font-semibold items-center">
            <p className="mr-1.5">Design by DVN</p>
            <img src="/images/dvn.png" alt="dichvunuoc.vn" height={20} width={20}/>
          </div>
        </div>
      </div>
    </section>
  );
}
